var _style, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg8WellLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 214 60",
    style: {
      enableBackground: "new 0 0 214 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.8405,
    y1: 47.9323,
    x2: 17.0452,
    y2: 11.2067,
    gradientTransform: "matrix(1 0 0 -1 0 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1B36FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FCF1"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.8,20.5v18.3l-13,13H13.7l-4.1-4.1l-2.2-2.1l0,0c-2.6-2.6-4.1-6.2-4.1-9.9v-8.8v-3.1l0,0 c0-3.7,1.5-7.2,4.1-9.9l2.2-2.2l4.1-4.1l2.2-2.2l0,0c2.6-2.6,6.2-4.1,9.9-4.1h3.1l-6.3,6.3l-6.6,6.6l-6.3,6.3v18.3l6.6,6.6h22.1 l9.3-9.3V23l-9.3-9.1H25.1l6.3-6.3h9.4L53.8,20.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.9256,
    y1: 24.733,
    x2: 55.5325,
    y2: 39.7857,
    gradientTransform: "matrix(1 0 0 -1 0 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1B36FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FCF1"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60,23.7v11.9c0,3.7-1.5,7.2-4.1,9.9l-6.3,6.3l-2.2,2.2l0,0c-2.6,2.6-6.2,4.1-9.9,4.1H25.6 c-3.7,0-7.2-1.5-9.9-4.1l-2.2-2.2h27.2l13-13V20.5l-13-13h-9.4L25,13.9l-9.3,9.3v13.1l9.3,9.3h-8.8l-6.6-6.6V20.5l6.3-6.3l6.6-6.6 l6.3-6.3h8.8c3.7,0,7.2,1.5,9.9,4.1l2.2,2.2l4.1,4.1l2.2,2.2l0,0C58.5,16.5,60,20.1,60,23.7z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M98,40.4c0,3.7-1.3,6.6-4.1,8.7c-2.5,1.9-5.6,2.8-9.4,2.8s-6.9-1-9.4-3.1c-2.6-2.2-4-5.2-4-9 c0-2.4,0.7-4.4,2.2-6.3c1.5-1.8,3.2-2.9,5.6-3.7c-1.9-0.7-3.5-1.9-4.6-3.7c-1-1.6-1.6-3.5-1.6-5.7c0-3.2,1.2-5.9,3.7-7.8 c2.4-1.8,5.2-2.6,8.4-2.6s5.9,0.9,8.1,2.8c2.4,2.1,3.5,4.6,3.5,7.7c0,4.1-2.1,7.2-6.2,9.3C95.5,31.8,98,35.2,98,40.4z M93.4,39.9 c0-2.4-0.9-4.3-2.6-5.9c-1.6-1.5-3.7-2.2-6.2-2.2c-2.6,0-4.7,0.7-6.5,2.1c-1.8,1.5-2.6,3.5-2.6,6c0,2.5,0.9,4.4,2.6,5.9 c1.6,1.3,3.7,2.1,6.3,2.1c2.5,0,4.6-0.7,6.3-2.2C92.5,44.5,93.4,42.4,93.4,39.9z M92.1,21.1c0-2.1-0.7-3.8-2.2-5.2 c-1.5-1.3-3.2-2.1-5.3-2.1c-2.2,0-4.1,0.7-5.4,2.1c-1.5,1.3-2.1,3.1-2.1,5.4c0,2.2,0.7,3.8,2.2,5c1.3,1.2,3.2,1.8,5.3,1.8 c2.2,0,4-0.6,5.4-1.9C91.4,24.9,92.1,23.2,92.1,21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M151.4,19.5l-13.8,31.8h-0.7l-10.2-22.8l-10.2,22.8h-0.7l-13.5-31.8h4.3l9.7,23.1l10.2-23.1h0.7l10.2,23.1 l10-23.1C147.3,19.5,151.4,19.5,151.4,19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M187.8,35.8h-28.6c0.1,3.5,1.2,6.5,3.4,9c2.2,2.5,5.2,3.7,8.7,3.7c3.4,0,6.3-1,8.7-3.1c1-0.9,2.2-2.5,3.5-4.6 l3.4,1.8c-2.2,4.3-5.2,7.1-9,8.5c-1.9,0.7-4,1-6.3,1c-4.7,0-8.7-1.6-11.9-4.7c-3.2-3.1-4.7-7.1-4.7-11.9c0-4,1.2-7.7,3.7-10.7 c3.1-4,7.4-6,12.7-6c5.4,0,9.7,2.1,13,6.2C186.6,27.9,187.8,31.4,187.8,35.8z M183.2,32.1c-1-4-3.2-6.8-6.5-8.4 c-1.8-0.7-3.5-1.2-5.4-1.2c-3.1,0-5.7,1-8.1,2.9c-1.6,1.5-2.9,3.7-3.7,6.5h23.7V32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M199,51.4h-4.1V7.3h4.1V51.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M211,51.4h-4.1V7.3h4.1V51.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8WellLogo);
export default __webpack_public_path__ + "static/media/8well-logo.8d2c1c26d5b700c29dd17da59127e7b5.svg";
export { ForwardRef as ReactComponent };